import * as yup from 'yup';
import i18next from 'i18next';
import { CreateSubtenantDto } from '@lmt/shared-types';
import { isEmpty } from '../../measurements/copy-datablock-field/common';
import { isValid } from 'date-fns';

function t(value: string, options?: any) {
  return i18next.t(`translation:errors.${value}` as any, options);
}

const requiredMessage = () => i18next.t('translation:errors.required');

export const subtenantYupSchema: yup.Schema<CreateSubtenantDto> = yup.object({
  name: yup.string().required(requiredMessage),
  code: yup
    .string()
    .matches(/^\S*$/, () => i18next.t('translation:errors.no_spaces'))
    .required(requiredMessage)
    .length(
      3,
      () =>
        i18next.t('translation:errors.exact_length', {
          length: 3,
        }) as string,
    ),
  workingTimeStartInSeconds: yup
    .number()
    .nullable()
    .required(requiredMessage)
    .typeError(() => t('invalid_time')),
  workingTimeEndInSeconds: yup
    .number()
    .nullable()
    .required(requiredMessage)
    .typeError(() => t('invalid_time'))
    .test(
      'start-less-than-end',
      () => i18next.t('translation:errors.end_time_later_than_start_time'),
      (_value, context) => validateDate(context.parent),
    ),
});

function validateDate(subtenant: CreateSubtenantDto) {
  const startTime = subtenant.workingTimeStartInSeconds;
  const endTime = subtenant.workingTimeEndInSeconds;
  if (
    !isEmpty(startTime) &&
    !isEmpty(endTime) &&
    isValid(startTime) &&
    isValid(endTime)
  ) {
    return endTime! > startTime!;
  }
  return true;
}
